import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export const DemoBanner: React.FC = () => {
  const { isDemoMode } = useAuth();

  if (!isDemoMode) return null;

  return (
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-2 px-4 text-center text-sm font-medium">
      🎯 <strong>DEMO MODE</strong> - Some features may not work or have bugs in demo mode
    </div>
  );
};